import React from 'react';
import Nav from '../Page Components/Nav';
import Footer from "../Page Components/Footer";
import Card from "../Co Components/SquareCards";
import Square from "../Co Components/SquareCards";
import Title from "../Co Components/Titles";
import FAQ from '../assets/Images/FAQs.png';
import Rectangle from "../Co Components/RectangleCards";
import LineButton from "../Co Components/LineButton";
import { useEffect } from 'react';

const FAQs = () => {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <h1 className={'mt-10 bebas text-black sub-headings display-2 '}  >FAQs</h1>
            <div className={'d-flex flex-row flex-wrap container  justify-content-center'}>
                <div>
                  <img src={FAQ} width={500}/>
                </div>
                <div className="accordion accordion-flush col-lg-7" id="accordionFlushExample">
                <div className="accordion-item accordion-it rounded-5  mt-2">
                    <h2 className="accordion-header" id="flush-headingOne">
                        <button
                            className="accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="false"
                            aria-controls="flush-collapseOne"
                        >
                            How much time do you need to perform the service?
                        </button>
                    </h2>
                    <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingOne"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body" style={{fontSize:'15px'}}>
                            2-4 weeks is the average time we take. However, the size of the environment obviously will have a huge impact on the duration of the service.
                        </div>
                    </div>
                </div>
                <div className="accordion-item accordion-it rounded-5 mt-2">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button
                            className="accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseTwo"
                            aria-expanded="false"
                            aria-controls="flush-collapseTwo"
                        >
                            What can I expect from the pen-testing process?
                        </button>
                    </h2>
                    <div
                        id="flush-collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingTwo"
                        data-bs-parent="#accordionFlushExample"
                    >
                        <div className="accordion-body" style={{fontSize:'15px'}}>
                            a) Executive Summary: The vendor should submit a report to summarize the Scope, Approach, Findings, and recommendations, in a manner suitable for senior management.
<br/><br/>
b) Core Findings along with Risk Analysis: The vendor should submit a report bringing out the core findings of the VAPT conducted for network devices, security devices, servers and websites.
<br/><br/>
c) Detailed Findings/Checklists: The detailed findings of the VAPT would be brought out in this report which will cover in detail all aspects viz. Identification of vulnerabilities/ threats in the systems (specific to equipment’s/resources – indicating the name and IP address of the equipment with office and department name), Identification of threat sources, Identification of risk, Identification of inherent weakness, Servers/Resources affected with IP address etc. The report should classify the observations into the Critical/Non Critical category and assess the category of Risk Implication as Very High/High/Medium/Low risk based on the impact. The various checklist formats, designed and used for conducting the VAPT activity as per the scope, should also be included in the report separately for servers (different for different OS), Applications, Network equipment, Security equipment etc so that they provide minimum domain wise baseline security standard/practices to achieve a reasonably secure IT environment for technologies deployed by the Client. The reports should be substantiated with the help of snapshots/evidence/documents etc. from where the observations were made.
<br/><br/>
d) In-depth analysis of findings/ Corrective Measures & Recommendations along with Risk Analysis: The findings of the entire VAPT process should be critically analyzed and controls should be suggested as corrective/preventive measures for strengthening/safeguarding the IT assets of the Client against existing and future threats in the short/long term. The report should contain suggestions/recommendations for improvement in the systems wherever required. If recommendations for Risk Mitigation/Removal could not be implemented as suggested, alternative solutions to be provided. Also, if the formal procedures are not in place for any activity, evaluate the process & the associated risks and give recommendations for improvement as per the best practices.
<br/><br/>
e) Suggestion for Industry Best Practices: The vendor has to provide hardening parameters for OS, websites, web-based applications, databases, servers, network and security devices as per the industry best practices standard.
                        </div>
                    </div>
                </div>
                <div className="accordion-item accordion-it rounded-5 mt-2">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button
                            className="accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseThree"
                            aria-expanded="false"
                            aria-controls="flush-collapseThree"
                        >
                            Who needs to worry about data security?
                        </button>
                    </h2>
                    <div
                        id="flush-collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingThree"
                        data-bs-parent="#accordionFlushExample"
                        style={{}}
                    >
                        <div className="accordion-body" style={{fontSize:'15px'}}>
                            You may think that big businesses with more endpoints are more vulnerable than small businesses. Or, businesses with attractive data, like financial services companies or those in the healthcare industry, would be easy targets. That’s not always the case—of course, they hold an incredible amount of data, but it’s like trying to rob the Federal Reserve gold vault versus robbing a regular Joe on the street. Bigger businesses or those that handle sensitive data typically have the technology, regulations, and processes to protect themselves from cyberattacks.

<br/><br/>On the other hand, small and medium-sized businesses without dedicated IT expertise, cybersecurity technology, processes, or education are easy targets for hackers.
                        </div>
                    </div>
                </div>

                <div className="accordion-item accordion-it rounded-5 mt-2">
                    <h2 className="accordion-header" id="flush-headingFour">
                        <button
                            className="accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFour"
                            aria-expanded="false"
                            aria-controls="flush-collapseFour"
                        >
                            What are the costs of a cyber attack?
                        </button>
                    </h2>
                    <div
                        id="flush-collapseFour"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingFour"
                        data-bs-parent="#accordionFlushExample"
                        style={{}}
                    >
                        <div className="accordion-body" style={{fontSize:'15px'}}>
                            The costs of cybercrimes are seen to be continuously rising in the UK
 which faced a cyber attack with a cost of over $ 6.7 million while the
U.S shows cyber attack costs of more than $25,000 for nearly 40% of all
cyberattacks that took place.
<br/><br/>
According to the FBI investigating cyber intrusions, every single
American’s data has most likely been stolen and is now present on the
dark web. The deep web is as the name suggests-much deeper and vaster
than the surface web, with some estimates putting it as large as [5,000 times bigger](https://sgp.fas.org/crs/misc/R44101.pdf). Because it’s relatively new and growing at an unprecedented rate, however, exact numbers are difficult to come by.
                        </div>
                    </div>
                </div>
                <div className="accordion-item accordion-it rounded-5 mt-2">
                    <h2 className="accordion-header" id="flush-headingFive">
                        <button
                            className="accordion-btn"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseFive"
                            aria-expanded="false"
                            aria-controls="flush-collapseFive"
                        >
                            How does good cyber security operate?
                        </button>
                    </h2>
                    <div
                        id="flush-collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="flush-headingFive"
                        data-bs-parent="#accordionFlushExample"

                    >
                        <div className="accordion-body" style={{fontSize:'15px'}}>
                            Good cybersecurity operates by implementing a comprehensive and proactive approach to protect digital systems, data, and networks from a wide range of cyber threats. Here are key principles and practices that define effective cybersecurity:
<br/><br/>
                            1. <b>Risk Assessment</b>: Start by identifying and assessing potential cybersecurity risks specific to your organization. Understand what data and systems are most critical and what threats they face.
                            <br/><br/>
                            2. <b>Policies and Procedures</b>: Develop clear cybersecurity policies and procedures that outline how to safeguard assets, what to do in case of an incident, and how to maintain compliance with relevant regulations.
                            <br/><br/>
                            3. <b>Access Control</b>: Implement strict access controls, ensuring that only authorized personnel have access to sensitive data and systems. Use strong, unique passwords and enable multi-factor authentication.
                            <br/><br/>
                            4. <b>Regular Updates and Patch Management</b>: Keep all software, hardware, and security systems up to date with the latest patches and updates to fix vulnerabilities.
                            <br/><br/>
                            5. <b>Network Security</b>: Use firewalls, intrusion detection systems, and intrusion prevention systems to protect the network. Segment networks to limit lateral movement by attackers.
                            <br/><br/>
                            6. <b>Endpoint Security</b>: Employ endpoint protection software to secure individual devices like computers and mobile devices. This includes antivirus software and endpoint detection and response (EDR) tools.
                            <br/><br/>
                            7. <b>Data Encryption</b>: Encrypt sensitive data both in transit and at rest to protect it from unauthorized access. Utilize strong encryption algorithms and key management practices.
                            <br/><br/>
                            8. <b>Incident Response Plan</b>: Develop and regularly test an incident response plan that outlines steps to take in the event of a cybersecurity incident. This includes identifying, containing, eradicating, and recovering from threats.
                            <br/><br/>
                            9. <b>Employee Training and Awareness</b>: Train employees on cybersecurity best practices and create a culture of security awareness. Human error is a common entry point for cyber threats.
                            <br/><br/>
                            10. <b>Continuous Monitoring</b>: Implement continuous monitoring of networks and systems to detect and respond to threats in real-time.
                            <br/><br/>
                            11. <b>Backup and Recovery</b>: Regularly back up critical data and test data restoration processes. This helps in case of data loss due to cyberattacks or other disasters.
                            <br/><br/>
                            12. <b>Vendor and Supply Chain Security</b>: Assess and manage the security of third-party vendors and supply chain partners that have access to your systems or data.
                            <br/><br/>
                            13. <b>Compliance and Regulation</b>: Stay compliant with relevant cybersecurity regulations and standards applicable to your industry.
                            <br/><br/>
                            14. <b>Security Awareness Training</b>: Educate employees about potential threats such as phishing attacks and social engineering tactics.
                            <br/><br/>
                            15. <b>Threat Intelligence</b>: Stay informed about emerging threats and vulnerabilities through threat intelligence sources and security advisories.
                            <br/><br/>
                            16. <b>Security Testing</b>: Conduct regular security assessments, including vulnerability scanning, penetration testing, and security audits.
                            <br/><br/>
                            17. <b>Business Continuity Planning</b>: Develop a business continuity and disaster recovery plan to ensure the organization can continue its operations even after a cyber incident.
                            <br/><br/>
                            18. <b>Collaboration and Information Sharing</b>: Collaborate with other organizations and share threat intelligence to collectively strengthen cybersecurity defenses.
                            <br/><br/>
                            Remember that cybersecurity is an ongoing process that requires vigilance and adaptability as the threat landscape evolves. No system can be completely immune to cyber threats, but a well-designed and well-maintained cybersecurity strategy can significantly reduce the risk and impact of such threats.
                        </div>
                    </div>
                </div>
            </div>
            </div>

            <Footer />
        </>
    );

}

export default FAQs;